import { ApolloLink, HttpLink } from '@apollo/client';
import { setContext } from '@apollo/client/link/context';
import { onError } from '@apollo/client/link/error';
import { push } from 'connected-react-router';
import { store } from '../../redux/store';

const baseHttpLink = new HttpLink({
  uri: `${process.env.REACT_APP_API_URL}/graphql`,
});

const authLink = ({ token }: { token: string }) =>
  setContext((_, { headers }) => {
    if (!token) return { headers };
    return {
      headers: {
        ...headers,
        authorization: `JWT ${token}`,
      },
    };
  });

const logoutLink = onError(({ networkError }) => {
  if (networkError && 'statusCode' in networkError && networkError.statusCode === 401) {
    store.dispatch({
      type: 'LOGOUT_REQUEST',
      payload: {
        data: {
          dontCheckForUnauthorized: true,
        },
      },
    });
    store.dispatch(push('/login'));
  }
});

export const httpLink = ({ token }: { token: string }): ApolloLink => ApolloLink.from([authLink({ token }), logoutLink, baseHttpLink]);
